export interface CarOwnerShip {
  type: CarOwnerShipType;
  name: string;
}
export type CarOwnerShipType =
  | 'private'
  | 'businesslike'
  | 'leasing'
  | 'rental';
